import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FiCpu, FiMail, FiSend } from "react-icons/fi";

import { authActions } from "../../store/auth";
import Autoresponder from "./autoresponder/Autoresponder";
import AiKeys from "./pages/AiKeys";
import Smtp from "./pages/Smtp";
import "./settings.css";

const tabs = [
  { id: "ai", label: "AI Keys", icon: FiCpu },
  { id: "smtp", label: "SMTP", icon: FiMail },
  { id: "autoresponder", label: "AutoResponder", icon: FiSend },
];

const ApiSetting = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("ai");

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  const renderPanel = () => {
    switch (activeTab) {
      case "ai":
        return <AiKeys />;
      case "smtp":
        return <Smtp />;
      case "autoresponder":
        return <Autoresponder />;
      default:
        return <AiKeys />;
    }
  };

  return (
    <section className="mid_wrap st-settings">
      {/* Hero Header with Tabs */}
      <div className="st-hero">
        <div className="container st-hero-container">
          <div className="st-hero-top">
            <div>
              <h1 className="st-hero-title">Settings</h1>
              <p className="st-hero-sub">Manage your API keys, email delivery, and integrations</p>
            </div>
          </div>

          {/* Top Tabs */}
          <div className="st-top-tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  type="button"
                  className={`st-top-tab${activeTab === tab.id ? " st-top-tab-active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <span className="st-top-tab-icon">
                    <Icon size={16} />
                  </span>
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="st-body">
        <div className="container st-body-container">
          <div className="st-panel" key={activeTab}>
            {renderPanel()}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApiSetting;
